// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";

import Scaler from "app/components/Scaler/Scaler";

type Props = {};

@observer
export default class ScalerContainer extends React.Component<Props> {
    render() {
        return <Scaler onScale={AppearanceStore.updateScale} />;
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/ScalerContainer.js